import { EmptyObject } from 'types/empty';
import { TextUploader } from './components/TextUploader';
import { ImageUploader } from './components/ImageUploader';
import { AudioUploader } from './components/AudioUploader';
import { UploadAreaStyles } from './UploadArea.styles';
import { Subtitle } from './components/Subtitle';
import { useUploadAreaContext } from './UploadAreaProvider/context';

const mediaUploader: { [key in CF.UI.UISupportedUploadTypes]: React.FC } = {
  text: TextUploader,
  image: ImageUploader,
  video: ImageUploader,
  'image,video': ImageUploader,
  audio: AudioUploader,
};

export function UploadArea({ children }: React.PropsWithChildren<EmptyObject>): JSX.Element | null {
  const { mediaType } = useUploadAreaContext();
  const Component = mediaUploader[mediaType as CF.UI.UISupportedUploadTypes];
  return (
    <div className={UploadAreaStyles} data-testid="upload-area">
      <Subtitle />
      <Component>{children}</Component>
    </div>
  );
}
